import React from 'react';
import { Trans } from 'react-i18next';
import { useMutation } from "@apollo/client";

import { UPDATE_BOOKING } from '../../../GraphQL/Mutations/bookings';
import { closePullout } from "../../../Actions/stakeholderActions";

export const CancelBookingButton = ({ calendarBooking, legacyAPICancelBooking, dispatch }) => {
    // const [updateBookingMutation, { data, loading, error }] = useMutation(UPDATE_BOOKING);

    const vehicleAlreadyReturned = Boolean(calendarBooking.Returned_On)

    // [not in use due to queue data sync implementation]
    const cancelBookingGraphQL = () => {
        // const { booking: gqlBooking } = calendarBooking.extendedProps

        // const cancelBookingInput = {
        //     id: parseInt(gqlBooking.id),
        //     status: 'cancelled'
        // }

        // updateBookingMutation({ variables: { input: cancelBookingInput } }).then((response) => {
        //     // showStatusMsg('Booking cancelled successfully.', 'success');
        //     // dispatch(closePullout());
        //     // calendarBooking.loadData();

        //     // [not in use due to queue data sync implementation]
        //     // window.location.reload();

        // }).catch((error) => {
        //     console.error('[updateBookingMutation] error: ', error);
        // });
    }

    const cancelBooking = () => legacyAPICancelBooking(cancelBookingGraphQL);

    return (
        <a
            className={"button alert ml-16" + (vehicleAlreadyReturned ? ' disabled' : '')}
            data-tip={vehicleAlreadyReturned ? 'Cannot cancel a booking that has been already checked in.' : null}
            onClick={vehicleAlreadyReturned ? null : cancelBooking}
        >
            <Trans>Cancel Booking</Trans>
        </a>
    )
}